import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps?: number;
  onStepClick?: (step: number) => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps = 5, onStepClick }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  
  const getStepLabel = (step: number): string => {
    switch (step) {
      case 1: return 'Nom';
      case 2: return 'URL';
      case 3: return 'Catégorie';
      case 4: return 'Filtres';
      case 5: return 'Options';
      default: return `${step}`;
    }
  };

  const handleStepClick = (step: number) => {
    // Permettre le clic uniquement sur les étapes bleues (déjà visitées)
    if (currentStep >= step && onStepClick) {
      onStepClick(step);
    }
  };

  return (
    <div className="w-full px-6 py-3 bg-cyan-50">
      <div className="flex items-center justify-between w-full max-w-full">
        {steps.map((step, index) => {
          const isCompleted = currentStep >= step;
          const isClickable = isCompleted && onStepClick;

          return (
            <React.Fragment key={step}>
              <div className="flex flex-col items-center">
                <div
                  onClick={() => handleStepClick(step)}
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all ${
                    isCompleted
                      ? 'bg-cyan-500 text-white'
                      : 'bg-gray-300 text-gray-500'
                  } ${
                    isClickable
                      ? 'cursor-pointer hover:bg-cyan-600 hover:scale-110'
                      : isCompleted
                      ? ''
                      : 'cursor-not-allowed'
                  }`}
                  title={
                    isCompleted
                      ? `Revenir à l'étape ${step}: ${getStepLabel(step)}`
                      : 'Étape non accessible'
                  }
                >
                  {step}
                </div>
                <span className="text-xs mt-1 text-gray-600">
                  {getStepLabel(step)}
                </span>
              </div>
              {index < totalSteps - 1 && (
                <div
                  className={`flex-1 h-1 mx-2 rounded transition-all ${
                    currentStep > step ? 'bg-cyan-500' : 'bg-gray-300'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
